import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {UrlConstants} from '../constants/url-constants';
import {UpdateLookupVo} from '../model/updateLookupVo';
import {SysAttrWrapper} from '../model/sysAttrWrapper';
import {ArrayOfKeys} from '../model/ArrayOfKeys';
import {SearchUpdateModelVO} from '../model/searchUpdateModelVO';
import {RSSRemitWrapper} from '../model/rSSRemitWrapper';
import {TransactionWrapper} from '../model/transactionWrapper';
import {DeliveryWrapper} from '../model/deliveryWrapper';
import {SeasonedLoanFeesWrapper} from '../model/seasonedLoanFeesWrapper';
import {SubmissionWrapper} from '../model/submissionWrapper';
import {ServicerTransferSummaryList} from '../model/servicerTransferSummaryList';
import {ServicerTransferSummary} from '../model/servicerTransferSummary';
import { SubmitTrialBalance } from '../model/submitTrialBalance';
import { ReverseTransaction } from '../model/ReverseTransaction';
import { ReportWrapper } from '../model/reportWrapper';
import { AdhocReportWrapper } from '../model/AdhocReportWrapper';
import { LoanWrapper } from '../model/loanWrapper';

@Injectable({providedIn: 'root'})
export class ApiService {

  public redirectUrl: string;
  userDetails = new BehaviorSubject(null);
  approvedDeletedTransferList: ServicerTransferSummaryList;
  servicerTransferSummary: ServicerTransferSummary;
  transactionList: any[];

  constructor(private http: HttpClient) {
  }

  public getApprovedDeletedList() {
    return this.approvedDeletedTransferList;
  }

  public setServiceTransferForPartial(serviceTransferSummary: ServicerTransferSummary)
  {
    this.servicerTransferSummary = serviceTransferSummary;
  }

  public setTransactionList(transactionList)
  {
    this.transactionList = transactionList;
  }

  public getTransactionList()
  {
    return this.transactionList;
  }

  public getServiceTransferForPartial()
  {
    return this.servicerTransferSummary;
  }


  public executeQuery(transactionWrapper: TransactionWrapper)
  {
    const url = UrlConstants.getServer() + UrlConstants.EXECUTE_QUERY;
    return this.http.post(url, transactionWrapper).pipe(
      map(response => response),
      catchError(this.handleError));
  }


  public saveApprovedDeletedList( approvedDeletedTransferList: ServicerTransferSummaryList)
  {
    this.approvedDeletedTransferList = approvedDeletedTransferList;
  }


  public getHolidayList(year: number): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.HOLIDAY_URL;
    return this.http
      .post(url, year).pipe(
        map(response => response),
        catchError(this.handleError));
  }




  public updateMaxAmtLimit(request: UpdateLookupVo): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.UPDATE_MAXAMT_URL;
    return this.http
      .post(url, request).pipe(
        map(response => response),
        catchError(this.handleError));
  }

  public updateGseLimit(request: UpdateLookupVo): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.UPDATE_GSEAMT_URL;
    return this.http
      .post(url, request).pipe(
        map(response => response),
        catchError(this.handleError));
  }

  public getGseLimit(state: string): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.GSEAMT_URL + '?stateName=' + state;
    return this.http
      .get(url).pipe(
        map(response => response),
        catchError(this.handleError));
  }

  public getMaxAmtLimit(state: string): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.MAXAMT_URL + '?stateName=' + state;
    return this.http
      .get(url).pipe(
        map(response => response),
        catchError(this.handleError));
  }

  public getStateList(): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.GSEAMTLIST_URL;
    return this.http
      .get(url).pipe(
        map(response => response),
        catchError(this.handleError));
  }

  public getMaxAmtStateList(): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.MAXAMTLIST_URL;
    return this.http
      .get(url).pipe(
        map(response => response),
        catchError(this.handleError));
  }

  public getSystemAttr(selAttr: string): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.GETSYSATTR_URL + '?' + selAttr;
    return this.http
      .get(url).pipe(
        map(response => response),
        catchError(this.handleError));
  }



  public getValueCache(): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.GETSYSATTR_URL ;
    return this.http
      .get(url).pipe(
        map(response => response),
        catchError(this.handleError));
  }


  public updateSysAttr(sysAttrVal: SysAttrWrapper): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.GETUPDTATTR_URL;
    return this.http
      .post(url, sysAttrVal).pipe(
        map(response => response),
        catchError(this.handleError));
  }

  public getCurrentProcessingDate(): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.CURRENTPROCESSINGDATE_URL;
    return this.http
      .get(url).pipe(
        map(response => response),
        catchError(this.handleError));
  }
  public getSeasonedLoanFees(seasonedLoanFeesWrapper: SeasonedLoanFeesWrapper): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.GET_SEASONED_LOAN_FEE_URL;
    return this.http
      .post(url, seasonedLoanFeesWrapper).pipe(
        map(response => response),
        catchError(this.handleError));

  }

  public updateSeasonLoanFees(seasonedLoanFeesWrapper: SeasonedLoanFeesWrapper): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.GET_UPDATE_LOAN_FEE_URL;
    return this.http
      .post(url, seasonedLoanFeesWrapper).pipe(
        map(response => response),
        catchError(this.handleError));

  }

  public addSeasonLoanData(seasonedLoanFeesWrapper: SeasonedLoanFeesWrapper): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.GET_ADD_SEASON_LOAN_FEE_DETAIL_URL;
    return this.http
      .post(url, seasonedLoanFeesWrapper).pipe(
        map(response => response),
        catchError(this.handleError));

  }

  public deleteSeasonLoanData(seasonedLoanFeesWrapper: SeasonedLoanFeesWrapper): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.GET_DELETE_SEASON_LOAN_FEE_DETAIL_URL;
    return this.http
      .post(url, seasonedLoanFeesWrapper).pipe(
        map(response => response),
        catchError(this.handleError));

  }

  public insertRSSEntry(rssEntryVal: RSSRemitWrapper): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.INSERT_RSS_ENTRY;
    return this.http
      .post(url, rssEntryVal).pipe(
        map(response => response),
        catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    // return an observable with a user-facing error message
    if (error != null && error.error != null && error.error.message != null && error.error.message !== undefined && error.error.message.includes('insert RSS records')) {
      // return throwError(
      //   'ErrorCode:${error.status},${error.error.message}');
      return throwError(
        `ErrorCode:${error.status},insert RSS records.`);
    } else if (error != null && error.error != null && error.error.message != null && error.error.message !== undefined && error.error.message.includes('violated while insert addSeasonedLoan')) {
      return throwError(
        `ErrorCode:${error.status},violated while insert addSeasonedLoan.`);
    } else if (error != null && error.error != null && error.error.message != null && error.error.message !== undefined && error.error.message.includes('Size: 0')) {
      return throwError(
        `ErrorCode:${error.status},empty resultset`);
    } else if (error != null && error.error != null && error.error.message != null && error.error.message !== undefined  && error.error.message.includes('Unable to update') && error.error.message.includes('Amount for the state')) {
      return throwError(
        `ErrorCode:${error.status},Unable to update`);
    } else if (error != null && error.error != null && error.error.message != null && error.error.message !== undefined ) {
      return throwError(
        `ErrorCode:${error.status},` + error.error.message);
    } else if (error != null && error.error != null &&  error.error.errorMessages != null && error.error.errorMessages !== undefined && error.error.errorMessages.length > 0) {
      return throwError(
        error.error.errorMessages);
    }
    return throwError(
      `ErrorCode:${error.status},Something bad happened; please try again later.`);
  }

  public healthCheck(): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.HEALTH_CHECK;
    return this.http.get(url).pipe(
      map(response => response),
      catchError(this.handleError));
  }

  public searchUpdateLoan(searchUpdateModel: SearchUpdateModelVO): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.SEARCH_UPDATE;
    return this.http.post(url, searchUpdateModel).pipe(
      map(response => response),
      catchError(this.handleError));
  }



  public getTransactionReverse(transactionWrapper: ReverseTransaction): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.EXECUTE_TRANSACTION_REVERSAL;
    return this.http.post(url, transactionWrapper).pipe(
      map(response => response),
      catchError(this.handleError));
  }



  public getServicerTransferList(transactionWrapper: TransactionWrapper): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.EXECUTE_QUERY_SERVICE_TRANSFER;
    return this.http.post(url, transactionWrapper).pipe(
      map(response => response),
      catchError(this.handleError));
  }

  public requestLoanDetails(arrayOfNumber: ArrayOfKeys): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.SEARCH_UPDATE_BY_PRIMARY_KEYS;
    return this.http.post(url, arrayOfNumber).pipe(
      map(response => response),
      catchError(this.handleError));
  }

  public requestTransDetails(transactionWrapper: TransactionWrapper): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.EXECUTE_QUERY_TRANS;
    return this.http.post(url, transactionWrapper).pipe(
      map(response => response),
      catchError(this.handleError));
  }

  public getLoanDetailResult(loanNumber: string): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.GET_LOAN_DETAILS;
    return this.http.post(url, { loanID : loanNumber}).pipe(
      map(response => response),
      catchError(this.handleError));
  }
  public getQueryLoanDetailResult(transactionWrapper: TransactionWrapper): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.GET_QUERY_LOAN_DETAILS;
    return this.http.post(url, transactionWrapper).pipe(
      map(response => response),
      catchError(this.handleError));
  }
  public retrieveLoanDetails(transactionWrapper: TransactionWrapper): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.EXECUTE_QUERY_PPA;
    return this.http
      .post(url, transactionWrapper).pipe(
        map(response => response),
        catchError(this.handleError));
  }

  updatePPA(deliveryWrapper: DeliveryWrapper): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.UPDATE_QUERY_PPA;
    return this.http
      .post(url, deliveryWrapper ).pipe(
        map(response => response),
        catchError(this.handleError));
  }

  public get(url: string, options?: any): Observable<any> {
    return this.http.get(url, options);
  }


  public copyFileFromCDXToS3Bucket(submissionWrapper: SubmissionWrapper): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.CDXToS3Bucket;
    return this.http
      .post(url, submissionWrapper ).pipe(
        map(response => response),
        catchError(this.handleError));
  }


  public getUserContactInfo(userContactWrapper: any): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.GET_USER_CONTACT_INFO;
    return this.http
      .post(url, userContactWrapper ).pipe(
        map(response => response),
        catchError(this.handleError));
  }


  public getQueryPayoff(transactionWrapper: TransactionWrapper): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.QUERY_PAYOFF;
    return this.http
      .post(url, transactionWrapper ).pipe(
        map(response => response),
        catchError(this.handleError));
  }

  public executeUnscheduledPaymentUserTransaction(transactionWrapper: TransactionWrapper): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.UNSCHEDULED_PAYOFF;
    return this.http
      .post(url, transactionWrapper ).pipe(
        map(response => response),
        catchError(this.handleError));
  }


  public getQueryPrePayment(transactionWrapper: TransactionWrapper): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.QUERY_PRE_PAYMENT;
    return this.http
      .post(url, transactionWrapper ).pipe(
        map(response => response),
        catchError(this.handleError));
  }


  public getQueryPaymentChange(transactionWrapper: TransactionWrapper): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.QUERY_PAYMENT_CHANGE;
    return this.http
      .post(url, transactionWrapper ).pipe(
        map(response => response),
        catchError(this.handleError));
  }

  public getLoanStatusMainten(transactionWrapper: TransactionWrapper): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.LOAN_STATUS_MAINTEN;
    return this.http
      .post(url, transactionWrapper ).pipe(
        map(response => response),
        catchError(this.handleError));
  }


  public executePayoffTransaction(transactionWrapper: TransactionWrapper): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.TRANSACTION_PAYOFF;
    return this.http
      .post(url, transactionWrapper ).pipe(
        map(response => response),
        catchError(this.handleError));
  }

  public callRAMSellerServAPI(userProfile: any): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.GET_SELL_SER_NUMBER;

    return this.http.post(url, userProfile).pipe(
      map(response => response),
      catchError(this.handleError));
  }

  public saveOrupdateContactInfo(userContactWrapper:any ) {
    const url = UrlConstants.getServer() + UrlConstants.UPDATE_CONTACT_INFO;

    return this.http.post(url, userContactWrapper).pipe(
      map(response => response),
      catchError(this.handleError));

  }

  public executeSubmitTrial(balance: SubmitTrialBalance): Observable<any>
  {
    const url = UrlConstants.getServer() + UrlConstants.EXECUTE_SUBMIT_TRIAL;
    return this.http.post(url, balance).pipe(
      map(response => response),
      catchError(this.handleError));
  }

  public downloadReport(wrapper: ReportWrapper): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.GET_REPORT;
    return this.http.post(url, wrapper, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  public getReportByLoanNumber(wrapper: AdhocReportWrapper): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.GET_REPORT_BY_LN_NUMBER;
    return this.http
      .post(url, wrapper, {
        responseType: 'blob',
        observe: 'response'
      });
  }

  public generateAdhocReport(wrapper: AdhocReportWrapper): Observable<AdhocReportWrapper> {
    const url = UrlConstants.getServer() + UrlConstants.ADHOC_REPORT;
    return this.http
      .post<AdhocReportWrapper>(url, wrapper).pipe(
        map(response => response));
  }

  public checkAdhocReportGenerated(fileName: string): Observable<any> {
    const url = UrlConstants.getServer() + UrlConstants.GET_ADHOC_REPORT + '?fileName=' + fileName;
    return this.http.get(url, {
      responseType: 'blob',
      observe: 'response'
    }).pipe(
      map(response => response),
      catchError(async (err) => {
        let msg = 'Unknown error';
        try {
          if (err.error instanceof Blob) {
            const errorText = await err.error.text();
            const errorJson = JSON.parse(errorText);
            msg = errorJson.message || errorText;
          } else if (err.error && err.error.message) {
            msg = err.error.message;
          } else {
          }
        } catch {
        }
        return msg;
      }));
  }

  public getPurchaseAdviceReport(wrp: LoanWrapper): Observable<any>
  {
    const url = UrlConstants.getServer() + UrlConstants.GET_PURCHASSE_ADVICE_CSV;
    return this.http.post(url, wrp, {
      responseType: 'blob',
      observe: 'response'
    }).pipe(
      map(response => response),
      catchError(this.handleError));
  }
}
